import { render, staticRenderFns } from "./ViewProjectLogDisputeModal.vue?vue&type=template&id=10e5ec9f&scoped=true&"
import script from "./ViewProjectLogDisputeModal.vue?vue&type=script&lang=js&"
export * from "./ViewProjectLogDisputeModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewProjectLogDisputeModal.vue?vue&type=style&index=0&id=10e5ec9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5ec9f",
  null
  
)

export default component.exports